import React from "react";
import { motion } from "framer-motion";
import { ShieldCheckIcon } from "lucide-react";
import { TransformButton } from "./TransformButton";
const POINTS = ["Explora los tomos", "Revisa los protocolos", "Utiliza los checklists", "Analiza los algoritmos"];
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-119" data-mp="1x420x72sge41">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-2xl rounded-3xl border-2 border-[var(--cta)]/25 bg-[var(--cream)] p-6 text-center sm:p-8" data-id="element-120" data-mp="1x28r5iwvpdrt">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--cta)]/12" data-id="element-121" data-mp="1j5c4zurpgkh9">
          <ShieldCheckIcon className="h-9 w-9 text-[var(--cta-dark)]" data-id="element-122" data-mp="1ec94t3sfacs3" />
        </div>
        <h2 className="font-serif-display text-2xl font-extrabold text-gray-900 sm:text-3xl" data-id="element-123" data-mp="qmydse0vjwr5">
          🛡️ Garantía Total de 7 Días
        </h2>
        <p className="mt-3 text-sm text-gray-600 sm:text-base" data-id="element-124" data-mp="ozjconbnbgqq">
          Prueba Protocolo Clínica Segura completamente sin riesgo.
        </p>

        <div className="mx-auto mt-5 flex max-w-md flex-wrap justify-center gap-2" data-id="element-125" data-mp="txkxbcopzo4b">
          {POINTS.map(p => <span key={p} className="rounded-full bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm" data-id="element-126" data-mp="ypurx60s5ccx">
              {p}
            </span>)}
        </div>

        <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-gray-600" data-id="element-127" data-mp="61p3o9aip58c">
          Si durante los próximos 7 días consideras que este sistema no aporta valor a tu práctica
          clínica… <strong className="text-[var(--cta-dark)]" data-id="element-128" data-mp="f0ako00ccc70">te devolvemos el 100% de tu dinero.</strong>
        </p>
        <p className="mt-2 text-xs text-gray-500" data-id="element-129" data-mp="k182gbhfv47z">
          Sin explicaciones. Sin formularios complicados. Sin letras pequeñas. Solo envíanos un correo. Así de simple.
        </p>

        <TransformButton label="Probar sin riesgo por 7 días" data-id="element-130" data-mp="1vesmoo8j5aa3" />
      </motion.div>
    </section>;
}